import { Link } from "react-router-dom";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "./ui/table";
import { Badge } from "./ui/badge";

function PositionBadge({ position }) {
  if (position === 1) return <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-mono font-bold win-badge rounded-sm">1</span>;
  if (position <= 3) return <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-mono font-bold place-badge rounded-sm">{position}</span>;
  return <span className="inline-flex items-center justify-center w-6 h-6 text-xs font-mono font-bold bg-zinc-100 text-zinc-600 rounded-sm">{position}</span>;
}

export default function RaceHistoryTable({ races }) {
  if (!races?.length) {
    return <p className="text-zinc-400 text-sm p-4">No race history available.</p>;
  }

  return (
    <div data-testid="race-history-table" className="border border-border overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow className="bg-zinc-50 hover:bg-zinc-50">
            <TableHead className="mono-label py-3 px-4">Date</TableHead>
            <TableHead className="mono-label py-3 px-4">Track</TableHead>
            <TableHead className="mono-label py-3 px-4">Race</TableHead>
            <TableHead className="mono-label py-3 px-4">Dist</TableHead>
            <TableHead className="mono-label py-3 px-4">Going</TableHead>
            <TableHead className="mono-label py-3 px-4 text-center">Pos</TableHead>
            <TableHead className="mono-label py-3 px-4">Rnrs</TableHead>
            <TableHead className="mono-label py-3 px-4">Jockey</TableHead>
            <TableHead className="mono-label py-3 px-4">Wgt</TableHead>
            <TableHead className="mono-label py-3 px-4">SP</TableHead>
            <TableHead className="mono-label py-3 px-4">Time</TableHead>
            <TableHead className="mono-label py-3 px-4">Prize</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {races.map((race, i) => (
            <TableRow key={race.id || i} data-testid={`race-row-${i}`} className="race-row-hover">
              <TableCell className="font-mono text-xs py-3 px-4 whitespace-nowrap">{race.date}</TableCell>
              <TableCell className="py-3 px-4">
                <span className="text-sm font-medium">{race.track_name}</span>
              </TableCell>
              <TableCell className="text-xs text-zinc-500 py-3 px-4 max-w-[160px] truncate">{race.race_name}</TableCell>
              <TableCell className="font-mono text-xs py-3 px-4">{race.distance}</TableCell>
              <TableCell className="text-xs py-3 px-4">{race.going}</TableCell>
              <TableCell className="py-3 px-4 text-center"><PositionBadge position={race.position} /></TableCell>
              <TableCell className="font-mono text-xs py-3 px-4 text-center">{race.runners}</TableCell>
              <TableCell className="text-xs py-3 px-4">{race.jockey}</TableCell>
              <TableCell className="font-mono text-xs py-3 px-4">{race.weight}</TableCell>
              <TableCell className="font-mono text-xs font-bold py-3 px-4">{race.sp}</TableCell>
              <TableCell className="font-mono text-xs py-3 px-4">{race.time}</TableCell>
              <TableCell className="font-mono text-xs py-3 px-4">{race.prize}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
